import React, { Component } from 'react';
import GlobalContextAction from "./GlobalContextAction.js";
import { jsx as _jsx } from "react/jsx-runtime";
class GlobalContextActions extends Component {
  render() {
    var _this$props = this.props,
      actions = _this$props.actions,
      dataTestId = _this$props['data-testid'];
    var actionElements = [];
    for (var i = 0; i < actions.length; i += 1) {
      var action = actions[i];
      var shortcut = action.shortcut;
      if (action.title != null || action.menuElement || shortcut) {
        var actionElement = /*#__PURE__*/_jsx(GlobalContextAction, {
          action: action,
          "data-testid": dataTestId
        }, "".concat(action.title, ".").concat(shortcut === null || shortcut === void 0 ? void 0 : shortcut.id));
        actionElements.push(actionElement);
      }
    }
    return actionElements;
  }
}
export default GlobalContextActions;
//# sourceMappingURL=GlobalContextActions.js.map